const STORAGE_KEY_ACTIVE = 'tour_active'
const STORAGE_KEY_COMPLETED = 'tours_completed'

function loadActiveTour() {
  try {
    const data = localStorage.getItem(STORAGE_KEY_ACTIVE)
    if (data && data !== 'undefined') {
      return JSON.parse(data)
    }
    return null
  } catch (e) {
    return null
  }
}

function loadCompletedTours() {
  try {
    const data = localStorage.getItem(STORAGE_KEY_COMPLETED)
    if (data && data !== 'undefined') {
      return JSON.parse(data)
    }
    return []
  } catch (e) {
    return []
  }
}

export default {
  namespaced: true,

  state: {
    activeTourId: null,
    currentStepIndex: 0,
    isActive: false,
    completedTours: loadCompletedTours()
  },

  getters: {
    isActive: state => state.isActive,
    activeTourId: state => state.activeTourId,
    currentStepIndex: state => state.currentStepIndex,
    isTourCompleted: state => tourId => state.completedTours.includes(tourId)
  },

  mutations: {
    START_TOUR(state, tourId) {
      state.activeTourId = tourId
      state.currentStepIndex = 0
      state.isActive = true
      localStorage.setItem(STORAGE_KEY_ACTIVE, JSON.stringify({ tourId, stepIndex: 0 }))
    },

    SET_STEP(state, stepIndex) {
      state.currentStepIndex = stepIndex
      if (state.activeTourId) {
        localStorage.setItem(STORAGE_KEY_ACTIVE, JSON.stringify({
          tourId: state.activeTourId,
          stepIndex
        }))
      }
    },

    END_TOUR(state) {
      if (state.activeTourId && !state.completedTours.includes(state.activeTourId)) {
        state.completedTours.push(state.activeTourId)
        localStorage.setItem(STORAGE_KEY_COMPLETED, JSON.stringify(state.completedTours))
      }
      state.activeTourId = null
      state.currentStepIndex = 0
      state.isActive = false
      localStorage.removeItem(STORAGE_KEY_ACTIVE)
    },

    QUIT_TOUR(state) {
      state.activeTourId = null
      state.currentStepIndex = 0
      state.isActive = false
      localStorage.removeItem(STORAGE_KEY_ACTIVE)
    },

    RESTORE_TOUR(state, { tourId, stepIndex }) {
      state.activeTourId = tourId
      state.currentStepIndex = stepIndex
      state.isActive = true
    }
  },

  actions: {
    startTour({ commit }, tourId) {
      // Tours are disabled in production
      if (process.env.NODE_ENV === 'production') return
      commit('START_TOUR', tourId)
    },

    nextStep({ commit, state }, totalSteps) {
      if (state.currentStepIndex < totalSteps - 1) {
        commit('SET_STEP', state.currentStepIndex + 1)
      }
    },

    prevStep({ commit, state }) {
      if (state.currentStepIndex > 0) {
        commit('SET_STEP', state.currentStepIndex - 1)
      }
    },

    goToStep({ commit }, stepIndex) {
      commit('SET_STEP', stepIndex)
    },

    endTour({ commit }) {
      commit('END_TOUR')
    },

    quitTour({ commit }) {
      commit('QUIT_TOUR')
    },

    restoreTour({ commit }) {
      const saved = loadActiveTour()
      if (saved) {
        commit('RESTORE_TOUR', saved)
      }
    }
  }
}
